module.exports = __webpack_public_path__ + "img/sq4d_banner.1655a2ff.jpg";